(function () {
  const OPEN_CLASS = 'is-open';

  function openDrawer(drawer, overlay) {
    drawer.classList.add(OPEN_CLASS);
    overlay.classList.add(OPEN_CLASS);

    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');

    var main = document.querySelector("main");
    if(main){
      main.style.zIndex = "52";
      main.style.position = "relative";
    }
    
    // Empêche le scroll de la page
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer(drawer, overlay) {
    drawer.classList.remove(OPEN_CLASS);
    overlay.classList.remove(OPEN_CLASS);

    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');

    var main = document.querySelector("main");
    if(main){
      main.style.zIndex = "1";
      main.style.position = "static";
    }

    document.documentElement.style.overflow = '';
  }

  // Gestion des clics
// Gestion des clics
document.addEventListener('click', function (e) {
  // Trigger pour ouvrir/fermer le drawer
  const trigger = e.target.closest('.card__colorpicker__trigger');
  if (trigger) {
    const id = trigger.dataset.id;
    if (!id) return;

    const drawer = document.getElementById(id);
    if (!drawer) return;

    const overlay = drawer.previousElementSibling;
    if (!overlay || !overlay.classList.contains('colorpicker-overlay')) return;

    // Toggle
    if (drawer.classList.contains(OPEN_CLASS)) {
      closeDrawer(drawer, overlay);
    } else {
      // Fermer tout autre drawer ouvert
      document.querySelectorAll('.card__colorpicker.is-open').forEach(d => {
        const ov = d.previousElementSibling;
        if (ov && ov.classList.contains('colorpicker-overlay')) {
          closeDrawer(d, ov);
        }
      });

      openDrawer(drawer, overlay);
    }

    e.preventDefault();
    return;
  }

  // Clic sur un overlay => fermer son drawer associé
  const overlay = e.target.closest('.colorpicker-overlay');
  if (overlay && overlay.classList.contains(OPEN_CLASS)) {
    const drawer = overlay.nextElementSibling;
    if (drawer && drawer.classList.contains('card__colorpicker')) {
      closeDrawer(drawer, overlay);
    }
  }

  // --- Nouveau : clic sur un élément qui ferme le drawer ---
  const closingTrigger = e.target.closest('.colorpicker-closing-trigger');
  if (closingTrigger) {
    const drawer = closingTrigger.closest('.card__colorpicker');
    if (!drawer) return;
    const overlay = drawer.previousElementSibling;
    if (!overlay || !overlay.classList.contains('colorpicker-overlay')) return;

    closeDrawer(drawer, overlay);
  }
});


  // Échap pour fermer le drawer ouvert
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const drawer = document.querySelector('.card__colorpicker.is-open');
      if (!drawer) return;

      const overlay = drawer.previousElementSibling;
      if (overlay && overlay.classList.contains('colorpicker-overlay')) {
        closeDrawer(drawer, overlay);
      }
    }
  });

  // Marque chaque drawer pour l'accessibilité
  function initDrawers() {
    document.querySelectorAll('.card__colorpicker').forEach(d => {
      d.setAttribute('role', 'dialog');
      d.setAttribute('aria-hidden', 'true');
      d.setAttribute('aria-modal', 'true');
    });

    document.querySelectorAll('.colorpicker-overlay').forEach(ov => {
      ov.setAttribute('aria-hidden', 'true');
    });
  }

  initDrawers();

  // Si Shopify recharge la section
  document.addEventListener('shopify:section:load', initDrawers);
  document.addEventListener('shopify:section:reorder', initDrawers);

})();
